module.exports = __webpack_public_path__ + "img/chart_3.2d61be91.png";